import React, { Component } from 'react';
import * as util from '../../../../utils/EnumMapping';
import MainTable from '../../../common/table/MainTable';
import * as columns from './CustomerColumns';
import NewCustomer from './NewCustomer';

class Customer extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "CUSTOMER";
            item.partnerTypeLabel = util.getLabel(util.partnerForBillTypes, item.type);
            item.state = util.getSecondValue(util.activeStates, item.active);
            item.stateLabel = util.getLabel(util.activeStates, item.active);
            return item;
        })
        return data;
    }

    render() {
        return (
            <MainTable
                divClassName="customer"
                tableName="Partnerek"
                newObjectLabel="Új partner hozzáadása"
                path='/api/customers'
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                dialogContent={(refresh, close) => <NewCustomer refresh={refresh} close={close} />} />
        );
    }
}

export default Customer;